"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.castToCamelCase = exports.castToSnakeCase = void 0;
const lodash_1 = require("lodash");
function castToSnakeCase(source) {
    return Object.keys(source).reduce((result, key) => ({
        ...result,
        [lodash_1.snakeCase(key)]: source[key],
    }), {});
}
exports.castToSnakeCase = castToSnakeCase;
function castToCamelCase(source) {
    return Object.keys(source).reduce((result, key) => ({
        ...result,
        [lodash_1.camelCase(key)]: source[key],
    }), {});
}
exports.castToCamelCase = castToCamelCase;
//# sourceMappingURL=Utilities.js.map